'use strict';

module.exports = {
    SIGN: 'Inicia sesión',
    SIGN_JOIN: '¡Bienvenid@!',
    EMAIL_EXISTS: 'Esta cuenta ya existe.',
    INVALID_EMAIL: 'Introduce un email válido',
    INVALID_FIRST_NAME: 'Introduzca un nombre válido',
    INVALID_LAST_NAME: 'Escribe sin acentos ni "ñ"',
    INVALID_PASSWORD: 'Introduce entre 6 y 20 caracteres alfanuméricos',
    INVALID_REPASSWORD: 'Las contraseñas no coinciden',
    INVALID_VALID_CODE: 'Introduce el código de la imagen',
    UNAVIALABLE_SERVICE: 'El servicio no está disponible, por favor inténtalo de nuevo más tarde.',
    EMPTY_VALID_CODE: 'Escriba los caracteres que ve en la imagen',
    NOT_MEMBER: 'Crea una cuenta',
    ALREADY_MEMBER: 'Inicia sesión',
    EMAIL: 'Introduce tu email',
    CONTACT_NAME: 'Nombre completo:',
    FIRST_NAME: 'Nombre:',
    LAST_NAME: 'Apellidos',
    PASSWORD: 'Contraseña',
    REPASSWORD: 'Repite la contraseña',
    EMPTY_CODE: 'Introduce el código de abajo:',
    REFRESH: 'Actualizar',
    CREATE_MY_ACCOUNT: 'Crear cuenta',
    NAME: 'Nombre',
    VERIFICATION: 'Código',
    AGREE_MENT: 'Al crear una cuenta estás aceptando el',
    AE_MEMBER_SHIP: 'Acepto los términos y condiciones de AliExpress.com',
    AND: 'y',
    PRIVACY_POLICY: 'Política de Privacidad',
    SLIDE_SUBMIT: 'Deslice a la derecha para comprobar',
    SLIDE_SUBMIT_TIPS: 'Misión cumplida',
    LOADING: 'Cargando...',
    SLIDE_SUBMIT_ERROR_TIPS: 'Deslice a la derecha para comprobar',
    SHOP_NOW: 'ENTRAR ',
    SIGN_IN: 'Identifícate',
    REGISTER_SMS: 'Registro por SMS',
    REGISTER_EMAIL: 'Registro por email',
    PHONE_NUMBER: 'Número de teléfono',
    VALID_NUMBER: 'Introduce un número de teléfono válido',
    SEND_SMS_CODE: 'Enviar código por SMS',
    SMS_POLICY: 'Recibirás un código de verificación por SMS al número que has introducido. Asegúrate de que el código del país y el número son correctos.',
    SEND_TO: 'Hemos enviado el código a',
    VERIFICATION_RECEIVED: 'Introduce el código de verificación que has recibido o',
    EDIT_NUMBER: 'usa otro número.',
    RESEND_CODE: 'Volver a enviar el código',
    LAST_STEP: 'Último paso',
    SET_SIGN_IN_PASSWORD: 'Introduce una contraseña de acceso para proteger tu cuenta.',
    INVALID_PHONE_PASSWORD: '6-20 characters (letters and numbers only)',
    NOT_CORRECT_CODE: 'El código no es correcto, vuelve a intentarlo.',
    SAVE_PASSWORD: 'Save password',
    NO_RECEIVED_CODE: 'Introduce de 6 a 20 caracteres (letras y números)',
    VIA_EMAIL: 'Aceptar'
};